// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2uH4x","inputWrap":"CustomTip_inputWrap__3Xsxd"};